import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import classNames from "classnames";
import { Container } from "react-bootstrap";
import Dashboard from "../../pages/Dashboard";
import Submission from "../../pages/Submission";
import Submissionprogress from "../../pages/Submissionprogress";
import SubmittedView from "../../pages/SubmittedView";
import RedirectView from "../../pages/RedirectView";
import Login2 from "../../pages/Login2";
import SubmissionTrackLogs from "../../pages/SubmissionTrackLogs";
import ManageReminders from "../../pages/ManageReminders";
import LevyAutomations from "../../pages/LevyAutomations";
import MicrosoftProtectedRoute from "../MicrosoftProtectedRoute"; 

const Content = () => {
  return (
    <Container
      fluid
      className={classNames("content bg-white p-0 m-0")}
    >
      <Routes>
        <Route path="/login" element={<Login2 />} />
        <Route path="/login" element={<Navigate to="/login" replace />} />

        {/* Protected routes using Microsoft authentication */}
        <Route
          path="/"
          element={
            <MicrosoftProtectedRoute>
              <Navigate to="/dashboard" replace />
            </MicrosoftProtectedRoute>
          }
        />
        <Route path="/dashboard" element={
          <MicrosoftProtectedRoute>
            <Dashboard />
          </MicrosoftProtectedRoute>
        } />
        <Route path="/submission" element={
          <MicrosoftProtectedRoute>
            <Submission />
          </MicrosoftProtectedRoute>
        } />
        <Route path="/Submissionprogress" element={
          <MicrosoftProtectedRoute>
            <Submissionprogress />
          </MicrosoftProtectedRoute>
        } />
        <Route path="/SubmittedView" element={
          <MicrosoftProtectedRoute>
            <SubmittedView />
          </MicrosoftProtectedRoute>
        } />
        <Route path="/submissions/:id" element={
          <MicrosoftProtectedRoute>
            <SubmittedView />
          </MicrosoftProtectedRoute>
        } />
        <Route path="/submission-logs/:id" element={
          <MicrosoftProtectedRoute>
            <SubmissionTrackLogs />
          </MicrosoftProtectedRoute>
        } />
        <Route path="/levy-automations" element={
          <MicrosoftProtectedRoute>
            <LevyAutomations />
          </MicrosoftProtectedRoute>
        } />
        <Route path="/manage-reminders/:id" element={
          <MicrosoftProtectedRoute>
            <ManageReminders />
          </MicrosoftProtectedRoute>
        } />
        <Route path="/docs/:id" element={
          <RedirectView />
        } />
      </Routes>
    </Container>
  );
};

export default Content;
